import SettingsIcon from "@mui/icons-material/Settings";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useMatch, useNavigate } from "react-router-dom";
import { useStyles } from "components/Layout/AppDrawer/components/DrawerItem.styles";
const DowntimeSettingsLink = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const matchPath = useMatch(
        `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`,
    );
    return (
        <ListItemButton
            className={`${classes.drawerItem} ${matchPath ? classes.drawerItemSelected : ""}`}
            onClick={() =>
                navigate(`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.SETUP_DASHBOARD}`)
            }
        >
            <ListItemIcon>
                <SettingsIcon className={classes.drawerItemIcon} />
            </ListItemIcon>
            <ListItemText
                primary={t("corporate_backoffice.corporate_layout.app_drawer.settings")}
                className={classes.drawerItemText}
            />
        </ListItemButton>
    );
};

export default DowntimeSettingsLink;
